import React, { useState } from "react";
import AddNewMedication from "../addMedication";
import { ModalType } from "../../../../shared/utils/enums";
import MainTable from "../../../../components/mainTable";
import { useDispatch } from "react-redux";
import { showModal } from "../../../../connected-components/modal/reducer";
import { screens } from "../../../../config/routes";
import { useNavigate } from "react-router-dom";
import { fetchMedications, deleteMedication } from "./actions";
import { Medication } from "../../../../interfaces/api/medications";
import { getMedicationsTableColumns } from "../../../../shared/tableColumns/medicationsColumns";

const MedicationsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [medications, setMedications] = useState<Medication[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    const loadMedications = async () => {
      setIsLoading(true);
      const res = await fetchMedications(1);
      if (res && res.result === "success" && res.content && res.content.data) {
        setMedications(res.content.data);
      }
      setIsLoading(false);
    };
    loadMedications();
    // eslint-disable-next-line
  }, [currentPage, pageSize]);

  const handleRowPress = (medication: Medication) => {
    navigate(screens.medicationDetails?.replace(":id", String(medication.id)));
  };

  const handlePageChange = ({
    pageIndex,
    pageSize: newPageSize,
  }: {
    pageIndex: number;
    pageSize: number;
  }) => {
    setCurrentPage(pageIndex);
    setPageSize(newPageSize);
  };

  const handleDeleteMedication = async (medication: Medication) => {
    const res = await deleteMedication(medication.id);
    if (res && res.result === "success") {
      setMedications((prev) => prev.filter((m) => m.id !== medication.id));
    }
  };

  const handleAddNewMedication = () => {
    dispatch(
      showModal({
        type: ModalType.COMPONENT,
        title: "Add New Medication",
        component: (
          <AddNewMedication
            onSuccess={(newMedication) => {
              setMedications((prev) => [newMedication, ...prev]);
            }}
          />
        ),
      }),
    );
  };

  const handleDeleteClick = (medication: Medication) => {
    dispatch(
      showModal({
        type: ModalType.QUESTION,
        title: "Delete Medication",
        message: `Are you sure you want to delete ${medication.name}?`,
        onConfirm: () => handleDeleteMedication(medication),
      }),
    );
  };

  const columns = getMedicationsTableColumns({ onDelete: handleDeleteClick });

  return (
    <div className="py-4">
      <MainTable
        columns={columns}
        data={medications}
        isLoading={isLoading}
        tableClass="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
        onRowPress={handleRowPress}
        showPagination={true}
        totalData={medications.length}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChanged={handlePageChange}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        showSearch={true}
        addButtonLabel="Add New Medication"
        onAddNewItemPress={handleAddNewMedication}
      />
    </div>
  );
};

export default MedicationsList;
